import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-consulta-decodificador-chassi',
  templateUrl: './consulta-decodificador-chassi.component.html',
  styleUrls: ['./consulta-decodificador-chassi.component.scss']
})
export class ConsultaDecodificadorChassiComponent implements OnInit {

  @Input() consulta: any;
  @Input() titulo="";
  @Input() idConsulta="";
  @Input() tipoConsulta="";
  @Input() codigoControle="";
  @Output() update = new EventEmitter();

  statusMsg = null;
  status = 'info';
  possuiInfoDecodificador: boolean;

  @Input() token = '';

  constructor() { }

  ngOnInit() {
    this.setStatus();
  }

  ngOnChanges() {
    this.setStatus();
  }


  setStatus() {
    if(this.consulta && this.consulta.quantidadeDeIrregularidades) {

      if(this.consulta.quantidadeDeIrregularidades == 0) {
        this.status = 'success';
        this.statusMsg = "CHASSI DECODIFICADO CORRETAMENTE";
      } else if(this.consulta.quantidadeDeIrregularidades == 1) {
        this.status = 'danger';
        this.statusMsg= "CHASSI DECODIFICADO INCORRETAMENTE, UM ERRO ENCONTRADO";
      } else if (this.consulta.quantidadeDeIrregularidades > 1) {
        this.status = 'danger';
        this.statusMsg= "CHASSI DECODIFICADO INCORRETAMENTE, FORAM ENCONTRADOS " + this.consulta.quantidadeDeIrregularidades + " ERROS";
      }

    }
  }

}
